module.exports = __webpack_public_path__ + "static/media/Greenpeach.8bde31ba.png";